import React from 'react';
import { FaMoneyBillWave } from 'react-icons/fa';
import { categoryLabels } from './constants';

export function DuesMyAccount({ myAccount, myPayments, onPayOnline }) {
  if (!myAccount) {
    return (
      <div className="bg-white rounded-xl border border-gray-200 p-8 text-center">
        <FaMoneyBillWave className="text-gray-300 text-5xl mx-auto mb-4" />
        <h3 className="text-lg font-semibold text-gray-700">No Dues Account</h3>
        <p className="text-gray-500">You don't have a dues account set up yet. Contact your family administrator.</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl border border-gray-200 p-6">
        <h3 className="text-lg font-bold text-gray-800 mb-4">My Dues Account</h3>
        <div className="grid md:grid-cols-3 gap-4">
          <div>
            <p className="text-gray-600">Category</p>
            <p className="text-xl font-bold text-gray-800">{categoryLabels[myAccount.category]}</p>
          </div>
          <div>
            <p className="text-gray-600">Total Paid</p>
            <p className="text-xl font-bold text-green-600">${myAccount.total_paid.toFixed(2)}</p>
          </div>
          <div>
            <p className="text-gray-600">Current Balance</p>
            {myAccount.balance < 0 ? (
              <>
                <p className="text-3xl font-bold text-red-600">${Math.abs(myAccount.balance).toFixed(2)}</p>
                <p className="text-sm text-red-500">Outstanding balance</p>
              </>
            ) : myAccount.balance > 0 ? (
              <>
                <p className="text-3xl font-bold text-green-600">$0.00</p>
                <p className="text-sm text-green-600">Credit: ${myAccount.balance.toFixed(2)}</p>
              </>
            ) : (
              <>
                <p className="text-3xl font-bold text-green-600">$0.00</p>
                <p className="text-sm text-green-600">Paid in full</p>
              </>
            )}
          </div>
        </div>
        
        <div className="mt-4 flex flex-wrap gap-3">
          <button onClick={onPayOnline} className="px-6 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700" data-testid="pay-online-btn">
            Pay Online
          </button>
        </div>
      </div>

      {/* My Payment History */}
      <div className="bg-white rounded-xl border border-gray-200 p-6">
        <h3 className="text-lg font-bold text-gray-800 mb-4">Payment History</h3>
        {myPayments.length > 0 ? (
          <div className="space-y-3">
            {myPayments.map(payment => (
              <div key={payment.payment_id} className="flex justify-between items-center border-b pb-3">
                <div>
                  <p className="font-medium text-gray-800">Receipt: {payment.receipt_number}</p>
                  <p className="text-sm text-gray-500">{new Date(payment.payment_date).toLocaleDateString()} - {payment.billing_period}</p>
                  {payment.notes && <p className="text-sm text-gray-600">{payment.notes}</p>}
                </div>
                <p className="text-lg font-bold text-green-600">+${payment.amount.toFixed(2)}</p>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-500 text-center py-4">No payments recorded yet</p>
        )}
      </div>
    </div>
  );
}
